import dayjs from "dayjs";

export const branchInitialValues = {
  is_main_branch: false,
  working_hours: {
    monday: {
      enabled: true,
      slots: [
        {
          start: dayjs("09:00", "HH:mm"),
          end: dayjs("17:00", "HH:mm"),
        },
      ],
    },
    tuesday: {
      enabled: true,
      slots: [
        {
          start: dayjs("09:00", "HH:mm"),
          end: dayjs("17:00", "HH:mm"),
        },
      ],
    },
    wednesday: {
      enabled: true,
      slots: [
        {
          start: dayjs("09:00", "HH:mm"),
          end: dayjs("17:00", "HH:mm"),
        },
      ],
    },
    thursday: {
      enabled: true,
      slots: [
        {
          start: dayjs("09:00", "HH:mm"),
          end: dayjs("17:00", "HH:mm"),
        },
      ],
    },
    friday: {
      enabled: true,
      slots: [
        {
          start: dayjs("09:00", "HH:mm"),
          end: dayjs("17:00", "HH:mm"),
        },
      ],
    },
    saturday: { enabled: false, slots: [] },
    sunday: { enabled: false, slots: [] },
  },
};

export const convertToHHmm = (schedule) => {
  const result = {};

  for (const [day, data] of Object.entries(schedule)) {
    result[day] = {
      enabled: data.enabled,
      slots: data.slots.map((slot) => ({
        start: dayjs(slot.start).format("HH:mm"),
        end: dayjs(slot.end).format("HH:mm"),
      })),
    };
  }

  return result;
};

export const convertHHmmToDayjs = (schedule) => {
  const result = {};

  for (const [day, data] of Object.entries(schedule)) {
    result[day] = {
      enabled: data.enabled,
      slots: data.slots.map((slot) => ({
        start: dayjs(slot.start, "HH:mm"),
        end: dayjs(slot.end, "HH:mm"),
      })),
    };
  }

  return result;
};
